import React, { useEffect, useState } from "react"
import { useAuth0 } from '@auth0/auth0-react';
import {Link} from "react-router-dom";
import {
    Typography,
    Card,
    Button,
    Table,
    Tag,
    Avatar,
    Tooltip
} from 'antd';
import {PlusCircleOutlined} from "@ant-design/icons";
import fetchApi from "../helper/fetchApi";
import useInterval from "../helper/useInterval";

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (_,record) => <><Link to={'/detail/'+record.id+'/'}>{record.name}</Link><Typography><Typography.Text type={'secondary'}>{record.file}</Typography.Text></Typography></>,
    },
    {
        title: 'State',
        dataIndex: 'state',
        key: 'state',
        render: (state) => {
            let color = 'gray';
            switch(state) {
                case 'PREPARATION':
                case 'TRANSFORMATION':
                case 'IMPORT':
                    color = 'blue';
                    break;
                case 'SUCCESFUL':
                    color = 'green';
                    break;
                case 'FAILED':
                    color = 'red';
                    break;
                default:
                    color = 'gray';
            }
            return (<Tag color={color} key={state}>
                {state}
            </Tag>);
        }
    },
    {
        title: 'Initiator',
        dataIndex: 'initiator',
        key: 'initiator',
        render: (initiator) => <Tooltip title={initiator}>
            <Avatar>{initiator.charAt(0).toUpperCase()}</Avatar>
        </Tooltip>,
    },
    {
        title: 'Created',
        dataIndex: 'created',
        key: 'created',
        render: (created) => <>{new Date(created).toLocaleDateString("en-US")} {new Date(created).toLocaleTimeString("en-US")}</>,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.created - b.created,
    },
    {
        title: 'Last update',
        dataIndex: 'updated',
        key: 'updated',
        render: (updated) => <>{new Date(updated).toLocaleDateString("en-US")} {new Date(updated).toLocaleTimeString("en-US")}</>,
        sorter: (a, b) => a.updated - b.updated,
    },
];

export default function JobDashboard() {
    const { getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect((data) => {
        (async () => {
            setLoading(true)
            let data = await fetchApi('imports/getList', getAccessTokenSilently);
            if(data !== null) {
                data = data.map((item) => {return {key: item.id, ...item}});
                setData(data);
                setLoading(false)
            }
        })()
    }, [])

    useInterval(() => {
        (async () => {
            setLoading(true)
            let data = await fetchApi('imports/getList', getAccessTokenSilently);
            if(data !== null) {
                data = data.map((item) => {return {key: item.id, ...item}});
                setData(data);
                setLoading(false)
            }
        })()
    }, 5000);

    return (
        <Card
            title={'Import Jobs'}
            extra={<Link to={'/new-job/'}><Button type="primary" icon={<PlusCircleOutlined />}>New import job</Button></Link>}
        >
            <Table columns={columns} dataSource={data} loading={loading} />
        </Card>
    );
}